import { useState } from "react";
import * as yup from 'yup';

const useHandleForm = (data, submitCallback, invalidDataCallback) => {

  const createInitialData = () => {

    const getInitialFieldData = (fieldName) => {
      return data?.[fieldName] ? [data?.[fieldName]] : [];
    }

    const fieldNames = [
      "module",
      "menu",
    ];

    return fieldNames.reduce((initialData, fieldName) => {
      return ({
        ...initialData,
        [fieldName]: getInitialFieldData(fieldName)
      })
    }, {});
  }

  const [formData, setFormData] = useState(() => createInitialData());

  const dataIsValid = async () => {
    const schema = yup.object().shape({
      module: yup.array().of(yup.string().required()),
      menu: yup.array().of(yup.string().required()),
    })
      .test(
        'module-xor-menu',
        'module and menu are mutually exclusive, and one must be provided with at least one item',
        ({ module, menu }) => {
          const hasModule = Array.isArray(module) && module.length > 0;
          const hasMenu = Array.isArray(menu) && menu.length > 0;
          return hasModule !== hasMenu;
        }
      );

    return await schema.validate(formData, { abortEarly: false })
      .then((castData) => castData)
      .catch(err => {
        if (err instanceof yup.ValidationError) {
          err.inner.forEach(error => {
            console.log(error.message);
          });
          return false;
        }
      });
  }


  const submit = async () => {
    console.log(formData)
    if (await dataIsValid()) {
      const dataToSend = {
        modules: formData.module,
        menus: formData.menu,
      };

      submitCallback(dataToSend);
      return true;
    } else {
      invalidDataCallback();
      return false;
    }
  }

  const setFormValue = (value, fieldName) => {
    setFormData((prev) => {
      return {
        ...prev,
        [fieldName]: value,
      }
    });
  }

  return {
    formData,
    setFormValue,
    submit,
  };
}

export default useHandleForm;